import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { ScrollSection } from '../components/ScrollSection';

function SeniorManagement() {
  const [management, setManagement] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchManagement();
  }, []);

  const fetchManagement = async () => {
    try {
      const response = await axios.get('/api/senior-management');
      setManagement(response.data.management || []);
    } catch (error) {
      console.error('Error fetching management:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {/* Simple Header */}
      <div className="container py-4" style={{ maxWidth: '1200px' }}>
        <nav aria-label="breadcrumb" className="mb-3">
          <ol className="breadcrumb mb-0">
            <li className="breadcrumb-item">
              <Link to="/" className="text-decoration-none" style={{ color: '#0066cc' }}>
                Home
              </Link>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              Senior Management
            </li>
          </ol>
        </nav>
        <h1 className="display-4 mb-0" style={{ fontFamily: 'Georgia, serif', fontWeight: 'bold', color: '#000' }}>
          Senior Management
        </h1>
      </div>

      {/* Main Content */}
      <div className="container py-5" style={{ maxWidth: '1200px', paddingLeft: '15px', paddingRight: '15px' }}>
        <ScrollSection>
          <div className="mb-5">
            <h2 
              style={{ 
                fontFamily: 'Georgia, serif', 
                fontWeight: 'bold', 
                color: '#0066cc', 
                fontSize: '2rem',
                marginBottom: '1rem'
              }}
            >
              Senior Management Team
            </h2>
            <p style={{ fontSize: '1.1rem', lineHeight: '1.8', color: '#333', marginBottom: '2rem', textAlign: 'justify' }}>
              Our senior management team consists of experienced healthcare professionals and administrators who bring
              years of expertise and dedication to their roles. They work collaboratively to ensure the hospital
              operates efficiently and delivers the highest quality of care to our patients.
            </p>
          </div>
        </ScrollSection>

        {loading ? (
          <ScrollSection>
            <div className="text-center py-5">
              <div className="spinner-border text-primary" role="status" style={{ width: '3rem', height: '3rem' }}>
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          </ScrollSection>
        ) : management.length > 0 ? (
          <ScrollSection>
            <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 row-cols-xl-4 g-4 tgh-senior-management-grid">
              {management.map((member) => (
                <div className="col" key={member.id}>
                  <div 
                    className="card h-100 border-0" 
                    style={{ 
                      boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                      transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                      borderRadius: '8px',
                      overflow: 'hidden'
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = 'translateY(-5px)';
                      e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.15)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = 'translateY(0)';
                      e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.1)';
                    }}
                  >
                    <Link
                      to={`/senior-management/${member.id}`}
                      className="text-decoration-none"
                    >
                      <div className="tgh-senior-grid-image-frame" style={{ 
                        width: '100%', 
                        paddingTop: '100%', 
                        position: 'relative', 
                        overflow: 'hidden',
                        backgroundColor: '#f8f9fa'
                      }}>
                        <img
                          src={member.image || '/img/Male Professional Headshot - East African.jpeg'}
                          alt={member.name}
                          className="tgh-senior-grid-image"
                          style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            width: '100%',
                            height: '100%',
                            objectFit: 'contain',
                          }}
                          onError={(e) => {
                            e.target.src = '/img/Male Professional Headshot - East African.jpeg';
                          }}
                        />
                      </div>
                    </Link>
                    <div className="card-body" style={{ 
                      padding: '1.25rem',
                      wordBreak: 'normal',
                      overflowWrap: 'break-word',
                      whiteSpace: 'normal'
                    }}>
                      <h5 
                        style={{ 
                          marginBottom: '0.5rem',
                          fontFamily: 'Georgia, serif',
                          fontSize: '1.1rem',
                          fontWeight: '600',
                          wordBreak: 'normal',
                          overflowWrap: 'break-word',
                          whiteSpace: 'normal'
                        }}
                      >
                        <Link
                          to={`/senior-management/${member.id}`}
                          className="text-decoration-none"
                          style={{ color: '#0066cc' }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.textDecoration = 'underline';
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.textDecoration = 'none';
                          }}
                        >
                          {member.name}
                        </Link>
                      </h5>
                      <p style={{ 
                        marginBottom: 0, 
                        fontSize: '0.95rem', 
                        color: '#666',
                        lineHeight: '1.5',
                        wordBreak: 'normal',
                        overflowWrap: 'break-word',
                        whiteSpace: 'normal'
                      }}>
                        {member.designation}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </ScrollSection>
        ) : (
          <ScrollSection>
            <div className="text-center py-5">
              <p style={{ fontSize: '1.1rem', color: '#666' }}>No management team members available at this time.</p>
            </div>
          </ScrollSection>
        )}
      </div>
    </>
  );
}

export default SeniorManagement;
